// extracted by mini-css-extract-plugin
export var orderSummary = "_q1-0";
export var showMoreLessButton = "_q1-1";